import { Controller } from '@hotwired/stimulus';

// Production / Sandbox scope switch for the template generations card. Toggles
// the rows (table + mobile cards) and the per-scope empty state by data-env.
export default class extends Controller {
  static targets = ['button', 'row', 'empty'];
  static values = { scope: { type: String, default: 'production' } };

  connect() {
    this.apply();
  }

  select(event) {
    this.scopeValue = event.currentTarget.dataset.scope;
  }

  scopeValueChanged() {
    this.apply();
  }

  apply() {
    this.buttonTargets.forEach((button) => {
      button.classList.toggle('is-active', button.dataset.scope === this.scopeValue);
    });
    this.rowTargets.forEach((row) => {
      row.hidden = row.dataset.env !== this.scopeValue;
    });
    this.emptyTargets.forEach((empty) => {
      empty.hidden = empty.dataset.env !== this.scopeValue;
    });
  }
}
